import { Component } from '@angular/core';

@Component({
  selector: 'app-new-account-api-unavailable-view',
  templateUrl: './new-account-api-unavailable-view.component.html',
  styleUrls: [
    '../shared-styles/new-account-device-view.component.scss',
    './new-account-api-unavailable-view.component.scss',
  ],
  standalone: false,
})
export class NewAccountApiUnavailableViewComponent {}
